import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["check", "price"]
  connect() { this.update() }
  update() { this.priceTarget.disabled = !this.checkTarget.checked }
}
